import { Component } from '@angular/core'

@Component({
  selector: 'aku-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent {

}
